import { Injectable } from '@angular/core';
import { NavMenuItem, ToolbarInfo } from '../../src';

@Injectable({
    providedIn: 'root'
})
export class ToolbarInfoService {
    public static $name: string = 'toolbarInfoService';

    private toolbarInfo: ToolbarInfo = {};

    public getParentNavMenuItem() {
        return this.toolbarInfo.parentNavMenuItem;
    }

    public getCurrentNavMenuItem() {
        return this.toolbarInfo.currentNavMenuItem;
    }

    public clearParentNavMenuItem() {
        this.unselectItem(this.toolbarInfo.parentNavMenuItem);
        this.toolbarInfo.parentNavMenuItem = null;
    }

    public clearCurrentNavMenuItem() {
        this.unselectItem(this.toolbarInfo.currentNavMenuItem);
        this.toolbarInfo.currentNavMenuItem = null;
    }

    public setParentNavMenuItem(item: NavMenuItem) {
        this.toolbarInfo.parentNavMenuItem = item;
    }

    public setCurrentNavMenuItem(item: NavMenuItem) {
        this.selectItem(item);
        this.toolbarInfo.currentNavMenuItem = item;
    }

    public getRootNameMenuItem() {
        return this.toolbarInfo.rootNameMenuItem;
    }

    public setRootNameMenuItem(item: NavMenuItem) {
        this.unselectItem(this.toolbarInfo.rootNameMenuItem);
        this.toolbarInfo.rootNameMenuItem = item;
        this.selectItem(item);
    }

    // Since we're dealing with an object reference here, nulling it out won't unselect it
    public unselectItem(item: NavMenuItem) {
        if (item) {
            item.isSelected = false;
        }
    }

    public selectItem(item: NavMenuItem) {
        if (item) {
            item.isSelected = true;
        }
    }
}
